import { useEffect } from 'react';

export default function usePageScroll(handler) {
  useEffect(() => {
    function onScroll(e) {
      handler(e);
    }
    document.body.addEventListener('scroll', onScroll);
    return () => document.body.removeEventListener('scroll', onScroll);
  }, []);
}
